import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Collapse,
  Chip,
} from "@mui/material";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import styled from "@emotion/styled";
import BudgetRow from "./BudgetRow";
import { formattedAmountWithoutAed } from "../../../../../../utils/CommonFunction";
import { renderCurrencyIcon } from "../../../../../../utils/CurrencyUtils";

const NO_IMAGE_SRC =
  "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b";

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 10px;
`;

const Row = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f7f7f7;
  border-radius: 12px;
  padding: 8px 16px;
`;

const Section = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MilestoneRow = ({ milestone, budgets, typeText, type }) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  return (
    <Container>
      <Row>
        <Box display="flex" alignItems="center" gap={1} width="33%">
          <Avatar src={NO_IMAGE_SRC} sx={{ height: 24, width: 24 }} />
          <Box>
            <Typography
              fontWeight={500}
              variant="caption"
              color="text.secondary"
            >
              {milestone.tags}
            </Typography>
            <Box display="flex" alignItems="center" gap={1}>
              <Typography variant="body2">{milestone.milestoneName}</Typography>
              <Chip label={typeText} color={type} />
            </Box>
          </Box>
        </Box>

        <Section sx={{ width: "20%" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            Start
          </Typography>
          <Typography variant="body2">{milestone?.startDate || "-"}</Typography>
        </Section>

        <Section sx={{ width: "20%" }}>
          <Typography fontWeight={500} variant="caption" color="text.secondary">
            End
          </Typography>
          <Typography variant="body2">{milestone?.endDate || "-"}</Typography>
        </Section>

        <Section sx={{ width: "20%", alignItems: "flex-end" }}>
          <Typography
            fontWeight={500}
            variant="caption"
            color="text.secondary"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            Amount ({renderCurrencyIcon("mweb")})
          </Typography>
          {formattedAmountWithoutAed(milestone.amount)}
        </Section>

        <Box display="flex" justifyContent="flex-end" gap={1} width="20%">
          <IconButton
            size="small"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
          </IconButton>
        </Box>
      </Row>

      <Collapse in={isExpanded}>
        <Box display="flex" flexDirection="column" gap={2}>
          {budgets?.map((budget) => (
            <BudgetRow key={budget.id} budget={budget} />
          ))}
        </Box>
      </Collapse>
    </Container>
  );
};

export default MilestoneRow;
